import { db } from "../firebase"
import firebase from "firebase"
import { useEffect, useState } from "react"
import { Alert } from "@mui/material"
import { Button, Card, TextField } from "@material-ui/core"

export default function SignedIn() {
    const [userProf, setUserProf] = useState(null)
    const [provideProfile, setprovideProfile] = useState({
        name: '',
        uid: '',
    })
    const [submitted, setsubmitted] = useState(false)
    const [userPending, setuserPending] = useState(null)

    function getProfile() {
        if (!firebase.auth().currentUser) return
        db.collection("appusers")
            .doc(firebase.auth().currentUser.uid)
            .get()
            .then((doc) => {
                setUserProf(doc.data())
                console.log(doc.data)
            })
            .catch((err) => {
                // setUserProf(null)
                console.log(err)
            })
    }

    function getPending() {
        if (firebase.auth().currentUser)
            db.collection('pendings').doc(firebase.auth().currentUser.uid)
                .get()
                .then((doc) => {
                    setuserPending(doc.data())
                })
                .catch((e) => {
                    console.log(e)
                })
    }

    function handleChange(event, val) {
        if (!val) val = event.target.value
        let newProvideProfile = provideProfile
        newProvideProfile[event.target.name] = val
        console.log(event.target.name, val)
        setprovideProfile(newProvideProfile)
    }

    function submitProfile() {
        db.collection("pendings")
            .doc(firebase.auth().currentUser.uid)
            .set({
                displayName: provideProfile.name,
                universityID: provideProfile.uid,
            }, { merge: true })
            .then(() => {
                setsubmitted(true)
            })
            .catch((err) => {
                // setUserProf(null)
                console.log(err)
            })
    }

    function sendSignupReq() {
        const user = firebase.auth().currentUser
        db.collection('pendings').doc(user.uid)
            .set({
                displayName: user.displayName,
                email: user.email,
                uid: user.uid,
            })
            .then(() => {
                console.log('Signup requset sent again to pendings')
            })
            .catch((e) => {
                console.log(e)
            })
    }

    useEffect(() => {
        console.log(provideProfile)
    }, [provideProfile])

    useEffect(() => {
        getProfile()
        getPending()
    }, [firebase.auth().currentUser])

    const form = (
        <div>
            <small>Optional</small>
            <p>
                To verify that you are a member of the club, you can provide your full name and uid here.
            </p>

            <Card className="flex-column padding form-width">

                <TextField className="margin padding" id="name" label="Full Name" name='name' variant="outlined" onChange={(event, newval) => { handleChange(event, newval) }}>
                </TextField>

                <TextField className="margin padding" id="uid" label="UID" name="uid" variant="outlined" onChange={(event, newval) => { handleChange(event, newval) }}>
                </TextField>

                {submitted ?
                    <Alert className="margin padding" color="success">Thank you for providing your full name and uid</Alert>
                    :
                    <Button className="margin padding" color="primary" variant="outlined" onClick={submitProfile}>Submit</Button>
                }
            </Card>
        </div>
    )

    const signupReqRejected = (
        <Alert color="error" >
            Admin didn't confirm your signup request. Please be aware, ANU Pennant and ANU Ladder is open for current members of the club. If you are a member but didn't get confirmed by the admin, please contact ANU Tennis Club.
        </Alert>
    )

    return (
        <div className="white-text padding margin">
            {userProf ?
                <Alert color="success">Welcome to ANU Tennis Club {userProf.displayName}. You are signed in.</Alert>
                :
                null
            }

            {userPending ?
                <div>
                    <Alert color="success">Your signup request has been received by admin. Once approved you are able to access contents on this site. This process can take up to 48 hours. If your signup request is not approved after 48 hours please contact ANU Tennis Club via Facebook Or Email.</Alert>
                    {form}
                </div>
                :
                null
            }

            {!userProf && !userPending ?
                signupReqRejected
                :
                null
            }

        </div>
    )
}